export var ALERTS_ROOT_PATH = '/realize/alerts';
export var ALERTS_LIST_PATH = '/realize/alerts/list';
export var ALERTS_SETTINGS_PATH = '/realize/alerts/settings';
export var API_TOKEN_EXPIRED_CODE = 403;
export var API_ACCESS_DENIED_CODE = 405;
export var UNAUTHORIZED_PATH = '/unauthorized';
export var REALIZE_DEFAULT_ERROR_MESSAGE = "Error while connecting to Druva Realize services. Please try after some time.\n  If the error persists, contact Druva Support.";
export var IS_DEV = true;
export var apiConfig = {};
export var SERVICES_LICENSED_FOR_ALERTS = ['Ransomware Recovery'];